import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const AuthLayout: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex justify-center items-center" style={{ background: '#F1F2DA' }}>
        <div className="w-12 h-12 border-2 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div
      className="min-h-screen flex flex-col justify-center items-center p-6 relative overflow-hidden"
      style={{ background: '#F1F2DA' }}
    >
      {/* Subtle orange grain texture via radial gradient */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(220,88,41,0.08) 0%, transparent 70%)',
        }}
      />

      {/* Combined lockup — cat + wordmark */}
      <div className="relative z-10 mb-8">
        <img
          src="/logo/salty-lockup.png"
          alt="Salty"
          style={{ height: 90, width: 'auto' }}
          draggable={false}
        />
      </div>

      {/* Login card */}
      <div
        className="w-full max-w-md relative z-10 rounded-2xl p-8 shadow-xl"
        style={{ background: '#ffffff', border: '1px solid rgba(220,88,41,0.12)' }}
      >
        <Outlet />
      </div>

      <p className="mt-6 text-xs relative z-10 tracking-wide" style={{ color: 'rgba(0,0,0,0.3)' }}>
        Powered by Amazon SES
      </p>
    </div>
  );
};
